<template>
  <el-dialog
    @open="iniciar"
    title="Gerar Boletos em Aberto"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    v-loading="isLoading"
    width="375px"
  >
    <el-form
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
      style="padding:0;"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="">
            <el-select v-model="form.geracao" style="width:100%;">
              <el-option label="Gerar Pdf" value="PDF" />
              <el-option label="Enviar por e-mail" value="E_MAIL" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Modelo">
            <el-select v-model="form.modelo" style="width:100%;">
              <el-option label="Boleto com Demonstrativo" value="BOLETO_COM_DEMONSTRATIVO" />
              <el-option label="Boleto Duplo" value="BOLETO_DUPLO" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="form.geracao == 'E_MAIL'">
        <el-col :span="24">
          <el-form-item label="E-mail">
            <el-input v-model="form.email" auto-complete="off" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="">
            <el-checkbox v-model="isGerarApenasRecibosComRemessaGerada">
              Gerar apenas boletos com remessa gerada
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button
        v-if="form.geracao == 'PDF'"
        @click="gerarBoletosEmAbertoHandler"
        type="primary"
        size="small"
        round
        class="btn-box-shadow">
        Gerar
      </el-button>

      <el-button
        v-if="form.geracao == 'E_MAIL'"
        @click="enviarBoletosEmAbertoHandler"
        type="primary"
        size="small"
        round
        class="btn-box-shadow">
        Enviar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    aluguel: Object,
    cliente: Object,
    recibos: Array,
    visibility: Boolean,
  },

  data() {
    return {
      form: {
        geracao: "PDF",
        modelo: "BOLETO_COM_DEMONSTRATIVO",
        email: "",
      },

      isGerarApenasRecibosComRemessaGerada: false,
    };
  },

  computed: {
    ...mapState({
      isLoading: state => state.loading,
    }),
    
    idsRecibosComRemessaGerada() {
      return this.recibos
        .filter(recibo => recibo.sequencialRemessa)
        .map(recibo => recibo.id);
    },

    naoExistemRecibosComRemessaGerada() {
      return this.idsRecibosComRemessaGerada.length === 0;
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),
    ...mapActions('alugueisClientesStore', [
      'gerarBoletosEmAbertoCliente',
      'enviarBoletosEmAbertoCliente',
    ]),

    iniciar() {
      this.isGerarApenasRecibosComRemessaGerada = false;
      this.form.email = this.cliente.email;
    },

    gerarBoletosEmAbertoHandler() {
      if(this.isGerarApenasRecibosComRemessaGerada && this.naoExistemRecibosComRemessaGerada) {
        this.$message.warning('Não existem boletos com remessa gerada');
        return;
      }

      const idsRecibos = this.isGerarApenasRecibosComRemessaGerada
        ? this.idsRecibosComRemessaGerada
        : [];

      idsRecibos.reverse();

      const payload = {
        aluguel: { id: this.aluguel.id },
        cliente: { id: this.cliente.id },
        modelo: this.form.modelo,
        idsRecibos,
      };
      
      this.showLoading();
      this.gerarBoletosEmAbertoCliente(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO": {
              const url = resultado.item;
              window.open(url, "_blank");
              break;
            }
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
          this.$emit('close');
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    showAlert(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'error' });
    },

    enviarBoletosEmAbertoHandler() {
      const isEmailInvalido = !this.form.email.trim();
      if(isEmailInvalido) {
        this.showAlert('Preencha o e-mail');
        return;
      }

      if(this.isGerarApenasRecibosComRemessaGerada && this.naoExistemRecibosComRemessaGerada) {
        this.showAlert('Não existem boletos com remessa gerada');
        return;
      }

      const payload = this.getPayloadEnviarEmail();

      this.showLoading();

      this.enviarBoletosEmAbertoCliente(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO": {
              this.$message.success(resultado.mensagem);
              this.$emit('close');
              break;
            }
            case "FALHA":
              this.showAlert(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    getPayloadEnviarEmail() {
      const idsRecibos = this.isGerarApenasRecibosComRemessaGerada
        ? this.idsRecibosComRemessaGerada
        : [];

      idsRecibos.reverse();

      const payload = {
        aluguel: { id: this.aluguel.id },
        cliente: { id: this.cliente.id, email: this.form.email },
        modelo: this.form.modelo,
        idsRecibos,
      };

      return payload;
    },

    fechar() {
      this.$emit('close');
    }, 
  },
};
</script>
